module.exports = "td, th {\n  white-space: normal;\n  padding: 3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/dictionary/profession/center-profession.component.scss
// module id = ./src/app/modules/user/components/dictionary/profession/center-profession.component.scss
// module chunks = main